// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, span, applet, object, iframe, h1, h2, h3, .order-history thead, .gift-cards .type label, .gift-cards .type .login-pane .spacer, .login-pane .gift-cards .type .spacer, h4, .return-instructions th, h5, [data-controller="help"] #contents .store-locator .leaflet-popup-content h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, .login-pane .spacer, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    /*font-size: 100%;*/
    vertical-align: baseline;
    letter-spacing: 1px;
}

body {
    padding: 0;
    font-family: Roboto;
    min-width: 320px;
    background: none !important;
}

h1, h2, h3, h4 {
    margin: 0;
    padding: 0;
    font-family: Arial, Helvetica, sans-serif;
}

a img {
    border: none;
}


body {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #333;
    margin: 0;
    padding: 0;
    overflow-x: hidden !important;
    overflow-y: auto;
}

body.open-modal{
    overflow: hidden !important;
}

.clearfix:after {
    content: '';
    display: block;
    clear: both;
}

.clear {
    clear: both;
    display: block;
    height: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
}

p {
    margin: 4px 0 15px;
    padding: 0;

}

a, a:active, a:hover, a:link, a:visited {
    color: black;
    text-decoration: underline;
    cursor: pointer;
    outline: 0;
}

/*h1, h2, h3, h4 {*/
    /*margin: 0;*/
    /*padding: 0;*/
    /*font-family: Arial, Helvetica, sans-serif;*/
/*}*/

img {
    border: 0;
}

input, label, select, textarea {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    color: #333;
    outline: 0;
}

button, input, select, textarea {
    margin: 0;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    display: inline-block;
    box-sizing: border-box;
}

button, input[type=button], input[type=submit] {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
    -webkit-border-radius: 0;
}

input:-webkit-autofill, select:-webkit-autofill, textarea:-webkit-autofill {
    background: #fff !important;
    color: #b4b4b4 !important;
}

select {
    box-sizing: border-box;
    color: #000;
    background: #fff;
    cursor: default;
}

strong {
    font-weight: bold;
}

#container {
    width: 100%;
    margin: 0 auto;
}

.inner-container {

    margin: 0 auto;
}

.headerBar {
    width: 100%;
    background: #002663;
    height: 20px;
    padding: 10px;
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}

.main-title {
    font-size: 14px;
}

.bt-brdr {
    padding-bottom: 5px;
    border-bottom: 2px solid #D8D8D8;
}

.word-break {
    white-space: pre;
}

.no-brdr {
    border: 0 !important;
}

.tc {
    text-align: center;
}

.tl {
    text-align: left;
}

input.btn, button.btn {
    display: block;
    border-radius: 6px;
    font-size: 15px;
    padding: 11px 38px 10px;
    float: none;
    cursor: pointer;
    line-height: 20px;
    margin-right: 20px;
    margin-bottom: 10px;
    width: 100%;
}

input.btn-sm, button.btn-sm {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
}

input.btn:active, input.btn:hover, button.btn:active, button.btn:hover {
    opacity: 0.5;
    filter: Alpha(Opacity=50);
}

input.blueBtn, button.blueBtn {
    color: #fff !important;
    border: 1px solid #002663;
    background: #002663;
}

input.greyBtn, button.greyBtn {
    color: #002663 !important;
    border: 1px solid #002663;
    background: #ffffff;
}

input.form-control {
    font-size: 11px;
    color: #333;
    background-color: #ffffff;
    border: 1px solid #ccc;
    padding: 6px 3px;
    width: 98%;
}

input.input-plain {
    border: none;
    color: #333333;
    width: 98%;
    padding: 6px 3px;
}

input.input-sm {
    width: 48%;
}

input.error {
    border: 1px solid rgb(155, 50, 16) !important;
}

.errorText {
    color: rgb(155, 50, 16) !important;
}

button:focus, input:focus {
    outline: none;
}

.cards-block {
    padding: 10px 0;
    border-bottom: 1px solid #d9d9d9;
}

.card-img img {
    width: 100%;
    max-width: 80px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield;
}

.no-pad {
    padding: 0 !important;
}

.no-mar {
    margin: 0 !important;
}

.display-none {
    display: none !important;
    speak: none;
}

.display-block {
    display: block !important;
    speak: normal;
}

.v-hidden {
    visibility: hidden !important;
    speak: none;
}

.v-visible {
    visibility: visible !important;
    speak: normal;
}

.rectangle-5 {
    border: 1px solid #D0021B;
    border-radius: 5px;
    position: relative;
    height: 10em;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.merchant-store-required {
    color: #000000;
    font-family: Helvetica;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%)
}

.form-control {
    font-size: 15px !important;
    color: #333;
    background-color: #ffffff;
    border: 1px solid #ccc;
    padding: none !important;
    width: 100% !important;
}

/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #53565A;
    color: #53565A;
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: .5s;
}

.dot-flashing::before, .dot-flashing::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
}

.dot-flashing::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #53565A;
    color: #53565A;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
}

.dot-flashing::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #53565A;
    color: #53565A;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
}

@keyframes dotFlashing {
    0% {
        background-color: #53565A;
    }
    50%,
    100% {
        background-color: #ECEDEE;
    }
}
`, "",{"version":3,"sources":["webpack://./static/styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,SAAS;IACT,cAAc;IACd,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,UAAU;AACd;;AAEA,mBAAmB;IACf,aAAa;IACb,cAAc;IACd,6CAA6C;AACjD,IAAI;;AAEJ;IACI,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,WAAW;IACX,UAAU;AACd;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;;;;EAIE;AACF;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,mDAAmD;IACnD,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;;QAEI,yBAAyB;IAC7B;AACJ","sourcesContent":["html, body, div, span, applet, object, iframe, h1, h2, h3, .order-history thead, .gift-cards .type label, .gift-cards .type .login-pane .spacer, .login-pane .gift-cards .type .spacer, h4, .return-instructions th, h5, [data-controller=\"help\"] #contents .store-locator .leaflet-popup-content h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, .login-pane .spacer, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    font: inherit;\r\n    /*font-size: 100%;*/\r\n    vertical-align: baseline;\r\n    letter-spacing: 1px;\r\n}\r\n\r\nbody {\r\n    padding: 0;\r\n    font-family: Roboto;\r\n    min-width: 320px;\r\n    background: none !important;\r\n}\r\n\r\nh1, h2, h3, h4 {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n}\r\n\r\na img {\r\n    border: none;\r\n}\r\n\r\n\r\nbody {\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    line-height: 18px;\r\n    color: #333;\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow-x: hidden !important;\r\n    overflow-y: auto;\r\n}\r\n\r\nbody.open-modal{\r\n    overflow: hidden !important;\r\n}\r\n\r\n.clearfix:after {\r\n    content: '';\r\n    display: block;\r\n    clear: both;\r\n}\r\n\r\n.clear {\r\n    clear: both;\r\n    display: block;\r\n    height: 0;\r\n    line-height: 0;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\np {\r\n    margin: 4px 0 15px;\r\n    padding: 0;\r\n\r\n}\r\n\r\na, a:active, a:hover, a:link, a:visited {\r\n    color: black;\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n    outline: 0;\r\n}\r\n\r\n/*h1, h2, h3, h4 {*/\r\n    /*margin: 0;*/\r\n    /*padding: 0;*/\r\n    /*font-family: Arial, Helvetica, sans-serif;*/\r\n/*}*/\r\n\r\nimg {\r\n    border: 0;\r\n}\r\n\r\ninput, label, select, textarea {\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: 12px;\r\n    color: #333;\r\n    outline: 0;\r\n}\r\n\r\nbutton, input, select, textarea {\r\n    margin: 0;\r\n    letter-spacing: normal;\r\n    word-spacing: normal;\r\n    text-transform: none;\r\n    text-indent: 0;\r\n    text-shadow: none;\r\n    display: inline-block;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbutton, input[type=button], input[type=submit] {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    -ms-appearance: none;\r\n    -o-appearance: none;\r\n    appearance: none;\r\n    -webkit-border-radius: 0;\r\n}\r\n\r\ninput:-webkit-autofill, select:-webkit-autofill, textarea:-webkit-autofill {\r\n    background: #fff !important;\r\n    color: #b4b4b4 !important;\r\n}\r\n\r\nselect {\r\n    box-sizing: border-box;\r\n    color: #000;\r\n    background: #fff;\r\n    cursor: default;\r\n}\r\n\r\nstrong {\r\n    font-weight: bold;\r\n}\r\n\r\n#container {\r\n    width: 100%;\r\n    margin: 0 auto;\r\n}\r\n\r\n.inner-container {\r\n\r\n    margin: 0 auto;\r\n}\r\n\r\n.headerBar {\r\n    width: 100%;\r\n    background: #002663;\r\n    height: 20px;\r\n    padding: 10px;\r\n    color: #ffffff;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}\r\n\r\n.main-title {\r\n    font-size: 14px;\r\n}\r\n\r\n.bt-brdr {\r\n    padding-bottom: 5px;\r\n    border-bottom: 2px solid #D8D8D8;\r\n}\r\n\r\n.word-break {\r\n    white-space: pre;\r\n}\r\n\r\n.no-brdr {\r\n    border: 0 !important;\r\n}\r\n\r\n.tc {\r\n    text-align: center;\r\n}\r\n\r\n.tl {\r\n    text-align: left;\r\n}\r\n\r\ninput.btn, button.btn {\r\n    display: block;\r\n    border-radius: 6px;\r\n    font-size: 15px;\r\n    padding: 11px 38px 10px;\r\n    float: none;\r\n    cursor: pointer;\r\n    line-height: 20px;\r\n    margin-right: 20px;\r\n    margin-bottom: 10px;\r\n    width: 100%;\r\n}\r\n\r\ninput.btn-sm, button.btn-sm {\r\n    width: 50%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\ninput.btn:active, input.btn:hover, button.btn:active, button.btn:hover {\r\n    opacity: 0.5;\r\n    filter: Alpha(Opacity=50);\r\n}\r\n\r\ninput.blueBtn, button.blueBtn {\r\n    color: #fff !important;\r\n    border: 1px solid #002663;\r\n    background: #002663;\r\n}\r\n\r\ninput.greyBtn, button.greyBtn {\r\n    color: #002663 !important;\r\n    border: 1px solid #002663;\r\n    background: #ffffff;\r\n}\r\n\r\ninput.form-control {\r\n    font-size: 11px;\r\n    color: #333;\r\n    background-color: #ffffff;\r\n    border: 1px solid #ccc;\r\n    padding: 6px 3px;\r\n    width: 98%;\r\n}\r\n\r\ninput.input-plain {\r\n    border: none;\r\n    color: #333333;\r\n    width: 98%;\r\n    padding: 6px 3px;\r\n}\r\n\r\ninput.input-sm {\r\n    width: 48%;\r\n}\r\n\r\ninput.error {\r\n    border: 1px solid rgb(155, 50, 16) !important;\r\n}\r\n\r\n.errorText {\r\n    color: rgb(155, 50, 16) !important;\r\n}\r\n\r\nbutton:focus, input:focus {\r\n    outline: none;\r\n}\r\n\r\n.cards-block {\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid #d9d9d9;\r\n}\r\n\r\n.card-img img {\r\n    width: 100%;\r\n    max-width: 80px;\r\n}\r\n\r\ninput[type=number]::-webkit-inner-spin-button,\r\ninput[type=number]::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n    -moz-appearance: textfield;\r\n}\r\n\r\n.no-pad {\r\n    padding: 0 !important;\r\n}\r\n\r\n.no-mar {\r\n    margin: 0 !important;\r\n}\r\n\r\n.display-none {\r\n    display: none !important;\r\n    speak: none;\r\n}\r\n\r\n.display-block {\r\n    display: block !important;\r\n    speak: normal;\r\n}\r\n\r\n.v-hidden {\r\n    visibility: hidden !important;\r\n    speak: none;\r\n}\r\n\r\n.v-visible {\r\n    visibility: visible !important;\r\n    speak: normal;\r\n}\r\n\r\n.rectangle-5 {\r\n    border: 1px solid #D0021B;\r\n    border-radius: 5px;\r\n    position: relative;\r\n    height: 10em;\r\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.merchant-store-required {\r\n    color: #000000;\r\n    font-family: Helvetica;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    text-align: center;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    margin-right: -50%;\r\n    transform: translate(-50%, -50%)\r\n}\r\n\r\n.form-control {\r\n    font-size: 15px !important;\r\n    color: #333;\r\n    background-color: #ffffff;\r\n    border: 1px solid #ccc;\r\n    padding: none !important;\r\n    width: 100% !important;\r\n}\r\n\r\n/**\r\n * ==============================================\r\n * Dot Flashing\r\n * ==============================================\r\n */\r\n.dot-flashing {\r\n    position: relative;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 5px;\r\n    background-color: #53565A;\r\n    color: #53565A;\r\n    animation: dotFlashing 1s infinite linear alternate;\r\n    animation-delay: .5s;\r\n}\r\n\r\n.dot-flashing::before, .dot-flashing::after {\r\n    content: '';\r\n    display: inline-block;\r\n    position: absolute;\r\n    top: 0;\r\n}\r\n\r\n.dot-flashing::before {\r\n    left: -15px;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 5px;\r\n    background-color: #53565A;\r\n    color: #53565A;\r\n    animation: dotFlashing 1s infinite alternate;\r\n    animation-delay: 0s;\r\n}\r\n\r\n.dot-flashing::after {\r\n    left: 15px;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 5px;\r\n    background-color: #53565A;\r\n    color: #53565A;\r\n    animation: dotFlashing 1s infinite alternate;\r\n    animation-delay: 1s;\r\n}\r\n\r\n@keyframes dotFlashing {\r\n    0% {\r\n        background-color: #53565A;\r\n    }\r\n    50%,\r\n    100% {\r\n        background-color: #ECEDEE;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
